import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-footer',
  standalone: false,
  templateUrl: './layout-footer.component.html',
  styleUrls: ['./layout-footer.component.scss']
})
export class LayoutFooterComponent {
 currentYear: number = new Date().getFullYear();
}
